var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.2997 16.359H2.64354V17.8974H15.2997V16.359ZM14.6897 8.79842L15.0434 11.9209L16.5721 11.7478L16.2184 8.62524L14.6897 8.79842ZM2.8998 11.9209L3.25352 8.79842L1.72484 8.62524L1.37112 11.7478L2.8998 11.9209ZM1.81987 14.4264C2.41952 13.7205 2.79494 12.8467 2.8998 11.9209L1.37112 11.7478C1.3002 12.3738 1.04668 12.9603 0.647431 13.4302L1.81987 14.4264ZM15.0434 11.9209C15.1483 12.8467 15.5237 13.7205 16.1233 14.4264L17.2958 13.4302C16.8965 12.9603 16.643 12.3738 16.5721 11.7478L15.0434 11.9209ZM2.64354 16.359C1.73401 16.359 1.15546 15.2083 1.81987 14.4264L0.647431 13.4302C-0.807974 15.1433 0.333944 17.8974 2.64354 17.8974V16.359ZM15.2997 17.8974C17.6092 17.8974 18.7512 15.1433 17.2958 13.4302L16.1233 14.4264C16.7877 15.2083 16.2092 16.359 15.2997 16.359V17.8974ZM16.2184 8.62524C15.7925 4.86639 12.6925 2 8.97161 2V3.53846C11.8744 3.53846 14.3479 5.78152 14.6897 8.79842L16.2184 8.62524ZM3.25352 8.79842C3.59528 5.78152 6.06881 3.53846 8.97161 3.53846V2C5.2507 2 2.15064 4.86639 1.72484 8.62524L3.25352 8.79842Z",
    fill: "#838383"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.7688 19.4494C12.9179 19.0516 12.7163 18.6083 12.3184 18.4592C11.9206 18.31 11.4773 18.5117 11.3282 18.9095L12.7688 19.4494ZM6.61496 18.9095C6.46587 18.5117 6.02252 18.31 5.6247 18.4592C5.22689 18.6083 5.02526 19.0516 5.17434 19.4494L6.61496 18.9095ZM11.3282 18.9095C10.9972 19.7927 10.084 20.4615 8.97157 20.4615V22C10.7003 22 12.204 20.9564 12.7688 19.4494L11.3282 18.9095ZM8.97157 20.4615C7.85916 20.4615 6.94593 19.7927 6.61496 18.9095L5.17434 19.4494C5.73911 20.9564 7.24286 22 8.97157 22V20.4615Z",
    fill: "#838383"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Noti",
    cx: 14,
    cy: 4,
    r: 4,
    fill: "#EA3434"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.3934f1173c77537e8d924d3b08f3b47d.svg";
export { ForwardRef as ReactComponent };